import React from "react";
import { MainLayout } from "../layouts/MainLayout";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Page403 from "../pages/403";

const HomePage = () => {
  const { me } = useSelector((state) => state.yodaStakeholders);

  const authFactory = () => {
    if (!me) {
      return <p>Loading....</p>;
    }

    if (me?.error === "not-authorized") {
      return (
        <Redirect
          to={{
            pathname: "/not-authorized",
            state: {
              yodaError: true,
            },
          }}
        />
      );
    }

    if (me?.role === "CustomerCare") {
      return <Redirect to="/agents" />;
    }

    if (me?.role === "Agents") {
      return <Redirect to={"/users/" + me.id} />;
    }

    if (me?.role === "Customer") {
      return <Redirect to={"/orders/" + me.id} />;
    }

    return <Page403 />;
  };

  return <MainLayout client>{authFactory()}</MainLayout>;
};

export default HomePage;
